import React from 'react';
import { Link, withRouter } from 'react-router';

import AuthRoutes from '../../routes/logged-in';

import './user-menu.scss';
import loginActions from '../../actions/login-actions';

class UserMenu extends React.Component {
    handleLogout() {
        loginActions.logout(this.props.userApiRequest);
    }

    render() {
        return (
            <ul className="user-menu">
                <li className="pure-menu-item">
                    <Link to={AuthRoutes.account}>
                        <span>{`Hi, ${this.props.user.name.split(' ').shift()}`}</span>
                    </Link>
                </li>
                <li className="pure-menu-item">
                    <Link to={AuthRoutes.bookmarks}>
                        <i className="icon-bookmark" />
                    </Link>
                </li>
                <li className="pure-menu-item">
                    <a onClick={this.handleLogout.bind(this)} className="logout-btn">
                        <i className="icon-logout" />
                    </a>
                </li>
            </ul>
        );
    }
}

export default withRouter(UserMenu);
